import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';
const Faces = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h4">
          Have you seen this before? Pretty sure the answer is YES! <br />{' '}
          <br />
          Just reorder it in the correct way and you will continue the game!
        </Typography>
      }
    />
  );
};

export default Faces;
